var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover as UiPopover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
export var Popover = function (_a) {
    var buttonContent = _a.buttonContent, children = _a.children, hidePadding = _a.hidePadding, bodyClassName = _a.bodyClassName, buttonClassName = _a.buttonClassName, containerClassName = _a.containerClassName, _b = _a.anchor, anchor = _b === void 0 ? 'bottom' : _b, _c = _a.triggerOn, triggerOn = _c === void 0 ? 'click' : _c;
    var triggerRef = useRef(null);
    var handleEnter = function (isOpen) {
        var _a;
        if (triggerOn !== 'hover')
            return;
        !isOpen && ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.click());
    };
    var handleLeave = function (isOpen) {
        var _a;
        if (triggerOn !== 'hover')
            return;
        isOpen && ((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.click());
    };
    return (_jsx(UiPopover, __assign({ className: "relative" }, { children: function (_a) {
            var open = _a.open;
            return (_jsxs("div", __assign({ onMouseEnter: function () { return handleEnter(open); }, onMouseLeave: function () { return handleLeave(open); }, className: containerClassName }, { children: [_jsx(PopoverButton, __assign({ className: twMerge('focus:outline-none', buttonClassName), ref: triggerRef }, { children: buttonContent })), open && (_jsx(PopoverPanel, __assign({ anchor: anchor, transition: true, className: twMerge('z-10 mt-1 flex origin-top flex-col rounded-md bg-white shadow-xl transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0', hidePadding ? 'p-0' : 'px-1 py-2', bodyClassName) }, { children: children })))] })));
        } })));
};
